<template>
    <div
        class="jike-task-detail-container"
        :class="
            detailData.platform && detailData.platform.value === 50
                ? 'dz-plat'
                : 'wx-plat'
        "
    >
        <div class="task-section">
            <div class="table-box" v-if="detailData.products">
                <div class="table-box-image">
                    <img :src="detailData.products[0].imageUrl" />
                </div>
                <div class="table-box-info">
                    <div class="product-name">
                        {{ detailData.products[0].name }}
                    </div>
                    <div class="product-price">
                        ￥ {{ detailData.products[0].price }} 元<span
                            class="free-tip"
                            >免费赠送</span
                        >
                    </div>
                    <div class="product-source">
                        <img
                            v-if="detailData.platform.value === 50"
                            src="../../assets/jike/dz.png"
                        />
                        <img
                            v-if="detailData.platform.value === 60"
                            src="../../assets/jike/wechat.png"
                        />
                        <span>{{ detailData.platform.desc }}发稿</span>
                    </div>
                </div>
            </div>
            <div class="rest-info">
                <span v-if="detailData.status && detailData.status.value === 30"
                    >剩余名额:
                    {{
                        detailData.applyPeopleMax - detailData.applySuccessTotal
                    }}</span
                >
                <span>参与人数：{{ detailData.applySuccessTotal }}</span>
                <span
                    v-if="detailData.status && detailData.status.value === 30"
                    style="float: right"
                    >剩余时间：{{ restTime }}</span
                >
                <span v-else style="float: right"
                    >报名截止时间：{{ detailData.applyEndTime }}</span
                >
            </div>
            <div class="follower-info">
                <img class="brand-img" :src="detailData.brandLogoUrl" />
                <span>{{ detailData.brandName }}</span>
                <div class="follower-info-count">
                    <img
                        class="icon-image follower-icon"
                        src="../../assets/jike/heart.png"
                    />
                    <span>{{ brandInfo.attentionCount }}人关注</span>
                </div>
            </div>
            <div class="shop-info">
                <div class="table-media-left shop-info-text">
                    <div>
                        <img
                            class="icon-image"
                            src="../../assets/jike/shop.png"
                        />
                        <span class="shop-info-text-title">{{
                            addInfo.realName
                        }}</span
                        ><span
                            style="color: #807f7f"
                            v-if="detailData.distance"
                        >
                            (距离您{{ detailData.distance }})</span
                        >
                    </div>
                    <div>
                        <div class="table-media-right shop-left">
                            <div class="table-media-right">
                                <img
                                    class="icon-image"
                                    src="../../assets/jike/map.png"
                                />
                            </div>
                            <div
                                class="table-media-right"
                                style="line-height: 20px"
                            >
                                <span class="address-info"
                                    >{{ addInfo.province }}{{ addInfo.city
                                    }}{{ addInfo.district
                                    }}{{ addInfo.address }}</span
                                >
                            </div>
                        </div>
                        <div class="table-media-right bottom">
                            <div class="nav-tel-container">
                                <!--                                <div @click='goNavigator' style="display: inline-block;">-->
                                <!--                                    <img class="icon-image" src="../../assets/jike/navigator.png" />-->
                                <!--                                </div>-->
                                <!--                                <span class="icon-divider">|</span>-->
                                <a
                                    style="display: inline-block"
                                    :href="'tel:' + addInfo.phone"
                                >
                                    <img
                                        class="icon-image"
                                        src="../../assets/jike/phone.png"
                                    />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="description-container">
            <span class="task-name">{{ detailData.name }}</span>
            <div class="richText" v-html="detailData.description"></div>
        </div>
        <div class="opt-container">
            <span class="upload-info" v-if="type === 'info'"
                >已提交任务{{
                    detailData.platform && detailData.platform.value === 50
                        ? "发布链接"
                        : "截图"
                }}</span
            >
            <span
                class="upload-notice-info"
                v-if="
                    detailData.status &&
                    detailData.status.value === 30 &&
                    type === 'edit'
                "
                >请按照任务要求发文，并上传{{
                    detailData.platform && detailData.platform.value === 50
                        ? "大众点评链接"
                        : "朋友圈截图"
                }}</span
            >
            <template
                v-if="detailData.platform && detailData.platform.value === 50"
            >
                <van-field
                    v-if="
                        detailData.status &&
                        detailData.status.value === 30 &&
                        type === 'edit'
                    "
                    v-model="dataUrl"
                    :formatter="formatter"
                    format-trigger="onBlur"
                    label-width="0"
                    class="input-url"
                    placeholder="请按照任务要求发文，复制文章链接，粘贴在此"
                />
                <span v-else class="upload-url">{{ dataUrl }}</span>
            </template>
            <van-uploader
                v-else
                :deletable="
                    type === 'edit' &&
                    detailData.status &&
                    detailData.status.value === 30
                "
                max-count="2"
                :show-upload="
                    type === 'edit' &&
                    detailData.status &&
                    detailData.status.value === 30
                "
                :file-list="fileList"
                :after-read="afterRead"
                @delete="delImg"
            ></van-uploader>
            <template v-if="type === 'edit'">
                <div v-if="optType === 'modify'" class="info-button-container">
                    <van-button class="modify-btn" @click="cancelModify"
                        >取消</van-button
                    >
                    <van-button class="get-profit-btn" @click="handleRight"
                        >确定修改</van-button
                    >
                </div>
                <template v-else>
                    <van-button
                        v-if="
                            detailData.status && detailData.status.value === 30
                        "
                        @click="handleRight"
                        class="get-profit-btn blobk-btn"
                        >获取免费体验权益</van-button
                    >
                    <van-button v-else class="get-profit-btn blobk-btn" disabled
                        >任务报名已结束</van-button
                    >
                </template>
            </template>
            <div v-if="type === 'info'" class="info-button-container">
                <van-button
                    class="modify-btn"
                    @click="modifyLink"
                    v-if="
                        taskApplyInfo.status &&
                        taskApplyInfo.status.value !== 100
                    "
                    >修改</van-button
                >
                <van-button class="get-profit-btn" @click="goRightPage"
                    >查看权益页面</van-button
                >
            </div>
        </div>
    </div>
</template>
<style lang="less">
.jike-task-detail-container {
    .blobk-btn {
        display: block;
        width: 100%;
    }
    padding-top: 15px;
    &.dz-plat {
        padding-bottom: 125px;
    }
    &.wx-plat {
        padding-bottom: 200px;
    }
    .task-section {
        padding: 0 15px;
        border-bottom: 8px solid #f1f1f1;
        .table-box {
            background: #ffffff;
            &-image {
                display: table-cell;
                vertical-align: middle;
                img {
                    width: 100px;
                    max-height: 100px;
                    margin-right: 15px;
                    border-radius: 5px;
                }
            }
            &-info {
                display: table-cell;
                .free-tip {
                    background: rgba(255, 109, 38, 0.3);
                    color: #ff6d26;
                    line-height: 18px;
                    display: inline-block;
                    transform: scale(0.8);
                }
                .product-source {
                    color: #171f24;
                    font-size: 12px;
                    img {
                        vertical-align: middle;
                        width: 20px;
                        max-height: 20px;
                        margin-right: 10px;
                    }
                }
                .product-name {
                    line-height: 40px;
                    color: #000000;
                    font-weight: bold;
                    font-size: 16px;
                    /* 商品名最长 50 字：限两行省略，避免长名把卡片撑高 */
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                }
                .product-price {
                    font-size: 13px;
                    color: #171f24;
                    line-height: 40px;
                    font-weight: bold;
                }
            }
        }
        .rest-info {
            line-height: 30px;
            font-size: 12px;
            color: #f42020;
            background: rgba(244, 32, 32, 0.15);
            box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            padding: 0 10px;
            margin-top: 25px;
            span {
                margin-right: 15px;
            }
        }
        .follower-info {
            border-bottom: 1px solid #dadada;
            font-size: 14px;
            font-weight: bold;
            line-height: 60px;
            margin-top: 10px;
            .follower-info-count {
                font-weight: normal;
                display: inline-block;
                float: right;
                .follower-icon {
                    width: 16px;
                    height: 16px;
                    vertical-align: middle;
                    margin-right: 5px;
                }
            }
            .brand-img {
                width: 30px;
                max-height: 30px;
                margin-right: 10px;
                vertical-align: middle;
                border-radius: 50%;
            }
        }
        .shop-info {
            padding: 10px 0;
            .nav-tel-container {
                width: 30px;
                .icon-divider {
                    margin: 0 12px;
                    color: #dadada;
                }
            }
            .shop-left {
                width: 1000px;
            }
            .table-media-left,
            .table-media-right {
                display: table-cell;
            }
            .table-media-left {
                width: 100%;
            }
            .table-media-right.bottom {
                vertical-align: bottom;
            }
            img {
                width: 16px;
                height: 16px;
                vertical-align: middle;
            }
            &-text {
                font-size: 14px;
                line-height: 35px;
                .address-info {
                    color: #807f7f;
                }
                img {
                    margin-right: 5px;
                }
                &-title {
                    font-weight: bold;
                }
            }
        }
    }
    .opt-container {
        box-sizing: border-box;
        padding: 5px 15px 15px;
        width: 100%;
        position: fixed;
        bottom: 0;
        box-shadow: 0px -2px 4px 0px rgba(2, 4, 51, 0.08);
        background: #ffffff;
        .get-profit-btn {
            color: white;
            font-size: 16px;
            line-height: 50px;
            background: linear-gradient(180deg, #ff6d26 0%, #f7b500 100%);
        }
        .input-url {
            margin-top: 10px;
            padding: 0 0 0 10px;
            line-height: 40px;
            height: 40px;
            font-size: 15px;
            box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
            border-radius: 6px;
            border: 1px solid #eeeeee;
            margin-bottom: 10px;
        }
        .info-button-container {
            display: flex;
            .modify-btn {
                margin-right: 15px;
            }
            button {
                display: table-cell;
                font-size: 16px;
                line-height: 50px;
            }
            .get-profit-btn {
                flex: 2;
                /* margin-left: 30rpx; */
            }
        }
        .upload-url {
            font-size: 12px;
            color: #ff0101;
            line-height: 20px;
            //line-height: 18px;
            word-break: break-all;
            padding: 10px 0;
            display: block;
        }
        .upload-info {
            color: #496fff;
            display: block;
            font-size: 12px;
        }
        .upload-notice-info {
            color: #7c8698;
            font-size: 12px;
            display: block;
            line-height: 24px;
        }
        /deep/.van-uploader {
            margin-top: 10px;
        }
    }
    .description-container {
        padding: 15px;
        //margin-bottom: 4px solid #f1f1f1;
        .task-name {
            color: #171f24;
            line-height: 40px;
            font-size: 19px;
        }
        .richText {
            word-break: break-all;
        }
    }
}
</style>
<script>
import {
    fetchTaskById,
    fetchTaskApplyById,
    addTaskLink,
    modifyTaskLink,
    fetchAddressById,
    fetchUpload,
} from "../../services/taskDetail";
import { fetchBrandById } from "@/services/brand";
import { Notify, Toast } from "vant";
import Cookies from "js-cookie";
const platformColor = {
    50: "#FF6633",
    60: "#46BB36",
};

export default {
    data() {
        return {
            aMapKey: "b935c33888a4fdfcb1c6a424ddcd50bd",
            taskApplyId: "",
            timer: "",
            restTime: "",
            brandId: "",
            brandInfo: {}, // 品牌详情
            taskId: "",
            detailData: {}, // 任务详情
            taskApplyInfo: {}, // 报名详情
            addInfo: {}, // 店铺信息
            dataUrl: "", // 上传链接
            fileList: [], // 上传图片列表
            type: "edit", // 是否是修改状态
            optType: "", // 提交接口是否是修改操作
            flag: 0, // 权益码是否解封
            locationData: undefined,
        };
    },
    mounted() {
        // if (data.lng & data.lat) {
        //     this.locationData = {
        //         latitude: data.lat,
        //         longitude: data.lng
        //     }
        // }
        const data = this.$route.query;
        this.taskId = data.id;
        if (this.taskId) {
            this.handleGetPageData(this.taskId, 1);
            console.log("taskInfo", Cookies.get("taskInfo"));
            window.handleAMapInit = this.handleAMapInit;
            const url = `https://webapi.amap.com/maps?v=1.4.15&key=${this.aMapKey}&callback=handleAMapInit`;
            const jsApi = document.createElement("script");
            jsApi.src = url;
            document.head.appendChild(jsApi);
            const token = Cookies.get("mini-token");
            if (token && token.indexOf("h5") > -1) {
                this.handleGetApplyData();
            }
        }
        this.$eventBus.$on("switchModify", (params) => {
            this.modifyLink();
        });
        this.$eventBus.$on("refresh_task_apply", (params) => {
            this.handleGetApplyData();
        });
    },
    beforeDestroy() {
        this.$eventBus.$off("switchModify");
        this.$eventBus.$off("refresh_task_apply");
    },
    methods: {
        handleAMapInit() {
            const that = this;
            window.AMap.plugin("AMap.Geolocation", function () {
                const geolocation = new window.AMap.Geolocation({
                    showButton: false, // 显示定位按钮，默认：true
                });
                geolocation.getCurrentPosition();
                window.AMap.event.addListener(geolocation, "complete", (e) => {
                    that.locationData = e.position;
                    that.handleGetPageData(that.taskId);
                }); // 返回定位信息
                window.AMap.event.addListener(geolocation, "error", (err) => {
                    console.log(err);
                    // that.handleGetPageData(that.taskId)
                }); // 返回定位出错信息
            });
        },
        formatter(val) {
            var req =
                /(https?|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
            return val.match(req) ? val.match(req)[0] : "";
        },
        modifyLink() {
            this.optType = "modify";
            this.type = "edit";
        },
        goRightPage() {
            this.$router.push({
                path: "/profitCode",
                query: {
                    id: this.taskApplyId,
                    taskId: this.taskId,
                    flag: this.flag,
                    name: this.detailData.products[0].name,
                },
            });
            //
        },
        isAndroid() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isAndroid =
                u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // android终端或者uc浏览器
            return isAndroid === true;
        },
        isIOS() {
            // true代表Android端 false代表ios端
            const u = navigator.userAgent;
            const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            return isiOS === true;
        },
        goNavigator() {
            const latCurrent = this.locationData.lat;
            const lngCurrent = this.locationData.lng;
            if (latCurrent && lngCurrent) {
                const urlObject = {
                    lat: this.addInfo.latitude,
                    lng: this.addInfo.longitude,
                    city:
                        this.addInfo.city === "市辖区"
                            ? this.addInfo.province
                            : this.addInfo.city,
                    name: this.addInfo.address,
                };
                let scheme = "";

                // urlObject 是我这边地址栏查询参数对象
                const queryStr =
                    "?origin=name:我的位置|latlng:" +
                    latCurrent +
                    "," +
                    lngCurrent +
                    "&destination=latlng:" +
                    urlObject.lat +
                    "," +
                    urlObject.lng +
                    "|name:" +
                    urlObject.name +
                    "&region=" +
                    urlObject.city +
                    "&coord_type=bd09ll&mode=driving";

                if (this.isIOS()) {
                    // ios 端
                    scheme = "baidumap://map/direction" + queryStr;
                } else {
                    // android 端
                    scheme = "bdapp://map/direction" + queryStr;
                }

                console.log(scheme);
                // 主要实现代码
                window.location.href = scheme;

                var startTime = Date.now();
                var count = 0;
                var endTime = 0;

                var t = setInterval(function () {
                    count += 1;
                    endTime = Date.now() - startTime;
                    if (endTime > 6200) {
                        clearInterval(t);
                    }
                    if (count < 300) return;
                    if (!(document.hidden || document.webkitHidden)) {
                        console.log(33333333);
                        window.location.href =
                            "http://api.map.baidu.com/direction" +
                            queryStr +
                            "&output=html";
                    }
                }, 20);

                window.onblur = function () {
                    clearInterval(t);
                };
            }
        },
        cancelModify() {
            this.handleGetApplyData();
            this.optType = "";
            this.type = "info";
        },
        countDown() {
            const that = this;
            this.djs();
            this.timer = setInterval(that.djs, 1000);
        },
        djs() {
            const that = this;
            // 获取当前时间
            const date = new Date();
            const now = date.getTime();
            // 设置截止时间
            const str = that.detailData.applyEndTime;
            const endDate = new Date(str.replace(/-/g, "/"));
            const end = endDate.getTime();
            // 时间差
            const leftTime = end - now;
            let h, m, s;
            if (leftTime >= 0) {
                // d = Math.floor(leftTime / 1000 / 60 / 60 / 24)
                h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
                m = Math.floor((leftTime / 1000 / 60) % 60);
                s = Math.floor((leftTime / 1000) % 60);
                // d = d > 9 ? d : '0' + d
                h = h > 9 ? h : "0" + h;
                m = m > 9 ? m : "0" + m;
                s = s > 9 ? s : "0" + s;
                that.restTime = `${h}:${m}:${s}`;
            } else {
                clearInterval(that.data.timer);
                that.restTime = "报名已结束";
            }
        },
        afterRead(file) {
            //
            const toast1 = Toast({
                type: "loading",
                message: "上传中",
            });
            file.status = "uploading";
            file.message = "上传中...";
            console.log(file);
            fetchUpload(file.file, 34)
                .then((res) => {
                    console.log(file);
                    file.status = "done";
                    this.fileList.push({
                        path: res.result,
                        url: `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${res.result}`,
                    });
                })
                .catch(() => {
                    file.status = "failed";
                    file.message = "上传失败";
                })
                .finally(() => {
                    toast1.clear();
                });
        },
        // 删除上传图片
        delImg(file, { name, index }) {
            this.fileList.splice(index, 1);
        },
        handleRight() {
            let params;
            let tempParams;
            if (this.detailData.platform.value === 50) {
                if (this.dataUrl === "") {
                    Notify({ type: "warning", message: "链接不能为空" });
                    return;
                }
                tempParams = params = {
                    dataUrl: this.dataUrl,
                };
            }
            if (this.detailData.platform.value === 60) {
                if (this.fileList.length === 0) {
                    Notify({ type: "warning", message: "至少传一张截图" });
                    return;
                }
                const images = this.fileList.map((item) => item.path);
                tempParams = this.fileList;
                params = {
                    supplemenImages: JSON.stringify({ images: images }),
                };
            }
            const optFunc =
                this.optType === "modify"
                    ? modifyTaskLink(this.taskApplyId, params)
                    : addTaskLink(this.taskId, params);
            optFunc
                .then((res) => {
                    if (res) {
                        this.type = "info";
                        this.handleGetApplyData();
                        Cookies.remove("taskInfo");
                    }
                })
                .catch((res) => {
                    if (res.code === 1001) {
                        Cookies.set("taskInfo", JSON.stringify(tempParams));
                    }
                    console.log("上传的信息", res);
                });
        },
        // 获取品牌信息
        handleGetBrandData(id) {
            fetchBrandById(id).then((res) => {
                this.brandInfo = res;
            });
        },
        // 获取地址信息
        handleGetAddData(id) {
            fetchAddressById(id)
                .then((res) => {
                    this.addInfo = res;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleGetApplyData() {
            fetchTaskApplyById(this.taskId).then((res) => {
                if (res !== null) {
                    console.log(3333333333, res);
                    this.taskApplyInfo = res;
                    this.type = "info";
                    this.taskApplyId = res.id;
                    this.flag = res.taskApplyExt.inviolableRightsFlag;
                    if (res.platform.value === 60) {
                        const imgs = JSON.parse(
                            res.taskApplyKpi.supplemenImages
                        ).images;
                        const mapImgs = imgs.map((item) => {
                            return {
                                url: `https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/${item}`,
                                path: item,
                            };
                        });
                        this.fileList = mapImgs;
                    } else {
                        this.dataUrl = res.submitUrl;
                    }
                }
            });
        },
        handleGetPageData(id, val) {
            const searchParams = {};
            if (this.locationData) {
                searchParams.latitude = this.locationData.lat;
                searchParams.longitude = this.locationData.lng;
            }
            fetchTaskById(id, searchParams)
                .then((res) => {
                    if (val) {
                        console.log(res);
                        this.handleGetBrandData(res.brandId);
                        this.handleGetAddData(res.merchantAddressId);
                        res.platformColor = platformColor[res.platform.value];
                        res.brandLogoUrl =
                            "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                            res.brandLogoUrl;
                        res.distance = res.distance
                            ? (res.distance / 1000).toFixed(2) + " km"
                            : "";
                        if (!res.products) res.products = [];
                        res.products = res.products.map((item) => {
                            return {
                                ...item,
                                price: item.price / 100,
                                imageUrl:
                                    "https://wowoto.oss-cn-shanghai.aliyuncs.com/pinboo/" +
                                    item.imageUrl,
                            };
                        });
                        // if (res.description.includes(`<img class=`)) {
                        //     res.description = res.description.replaceAll(/\<img class="/gi, '<img class="rich-img ')
                        // } else {
                        //     res.description = res.description.replaceAll(/\<img/gi, '<img class="rich-img"')
                        // }
                        this.detailData = res;
                        if (Cookies.get("taskInfo")) {
                            const taskInfo = JSON.parse(
                                Cookies.get("taskInfo")
                            );
                            console.log("jkjjjj", taskInfo);
                            if (this.detailData.platform.value === 50) {
                                this.dataUrl = taskInfo.dataUrl;
                            } else {
                                this.fileList = taskInfo;
                            }
                        }
                        this.countDown();
                    } else {
                        this.detailData.distance =
                            (res.distance / 1000).toFixed(2) + " km";
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
};
</script>
